module.exports = __webpack_public_path__ + "media/images/top/rank1_bg-e0636d733adc837baeb35a212118ba15.gif";